export const RANGE_QUERY_MIN_VALUE = 0.8;
export const LABEL_OUTLIER_QUERY_MIN_VALUE = 0.5;
